import apiClient from '../helpers/apiClient'
import {ApiArrayResponseModel} from '../hooks/community/models/ApiResponseModel'
import {CatalogItem} from '../pages/catalogAdmin/types'

// Generic CRUD service factory for a config-driven catalog. Thin apiClient wrappers matching
// the existing service idiom (membersAdminService). Reads are public; writes are admin-gated
// on the backend (IsAdminRole). Deactivate/reactivate are PATCHes on the model's soft-delete
// field — there is intentionally NO destroy() here, so the UI can never hard-delete a value.

export interface CatalogListParams {
  search?: string
  limit?: number
  offset?: number
}

export interface CatalogService {
  list: (params?: CatalogListParams) => Promise<ApiArrayResponseModel<CatalogItem>>
  create: (values: Record<string, unknown>) => Promise<CatalogItem>
  update: (id: number, values: Record<string, unknown>) => Promise<CatalogItem>
  reorder: (items: Array<{id: number; order: number}>) => Promise<{updated: number}>
}

export const createCatalogService = (endpoint: string): CatalogService => ({
  list: async (params: CatalogListParams = {}) => (await apiClient.get(endpoint, {params})).data,
  create: async (values) => (await apiClient.post(endpoint, values)).data,
  update: async (id, values) => (await apiClient.patch(`${endpoint}${id}/`, values)).data,
  reorder: async (items) => (await apiClient.post(`${endpoint}reorder/`, {items})).data,
})
